/*  eslint-disable */
import { batch } from 'react-redux';

import { API_EXPLORE_URL, isHiddenBook } from '../constants';
import { callApi } from '../utils';
import { setItems } from './threads';

const collectionContainsHiddenBook = collection =>
  collection.books?.results?.some(book => isHiddenBook(book));
import {
  exploreRecentColsThreadId,
  exploreFeaturedColsThreadId,
  exploreRecsThreadId,
  exploreReviewsThreadId,
} from '../selectors/explore';

export function fetchExplore({ dispatch, token }) {
  return callApi(API_EXPLORE_URL, { token }).then(data => {
    const {
      recommended,
      reviews,
      recentCollections,
      featuredCollections,
    } = data;
    const filteredRecent = recentCollections?.results?.filter(
      c => !collectionContainsHiddenBook(c)
    );
    const filteredFeatured = featuredCollections?.results?.filter(
      c => !collectionContainsHiddenBook(c)
    );
    batch(() => {
      const filteredRecs = recommended?.results?.filter(
        book => !isHiddenBook(book)
      );
      dispatch(setItems(exploreRecsThreadId, filteredRecs));
      dispatch(setItems(exploreFeaturedColsThreadId, filteredFeatured));
      const filteredReviews = reviews?.results?.filter(
        item => !isHiddenBook(item.book)
      );
      dispatch(setItems(exploreReviewsThreadId, filteredReviews));
      dispatch(setItems(exploreRecentColsThreadId, filteredRecent));
    });
  });
}
